import Feedback from '@data-platform/user-feedback';

import { domainBaseEnvironment } from './environment';

export const enum FeedbackType {
  ANYTIME = 'anytime',
  NPS = 'nps',
  CSAT = 'csat',
}

export function openInAppFeedback({
  type,
  context,
  event,
}: {
  type: string;
  context: string;
  event: string;
}) {
  Feedback.openFeedback({
    context: `${domainBaseEnvironment}-${type}.${context}`,
    event: `${domainBaseEnvironment}-${type}.${event}`,
  });
}
